import { useDeal } from './context';

export function Skeleton({ gridCols }) {
  const rows = Array.from(Array(10).keys()).map(i => (
    <div key={`key-${i}`} className={`grid gap-2 ${gridCols}`}>
      {Array.from(Array(8).keys()).map(j => (
        <div key={`${i}-${j}`} className="skeleton h-[30px]"></div>
      ))}
    </div>
  ));

  return (
    <div className=" opacity-50">
      <div className="mb-6 h-[64px] w-full shadow rounded-lg bg-white flex justify-between items-center space-x-4">
        <div className="p-2 px-4 w-full flex-shrink">
          <div className="skeleton w-full h-[32px]"></div>
        </div>
        <div className="flex space-x-2 flex-shrink-0 pr-4">
          <div className="skeleton w-[64px] h-[32px]"></div>
          <div className="skeleton w-[64px] h-[32px]"></div>
          <div className="skeleton w-[64px] h-[32px]"></div>
        </div>
      </div>
      <div className="w-full shadow rounded-lg bg-white flex flex-col divide-y">
        <div className="p-2 px-4 flex justify-between items-center">
          <div className="skeleton w-1/4 h-[32px]"></div>
          <div className="flex space-x-2  ">
            <div className="skeleton w-[32px] h-[32px]"></div>
            <div className="skeleton w-[32px] h-[32px]"></div>
            <div className="skeleton w-[32px] h-[32px]"></div>
          </div>
        </div>
        <div className="flex flex-col space-y-2 p-2 px-4">{rows}</div>
      </div>
    </div>
  );
}
